import { apiCall } from './gqlClient';

const GETPUBLICSESSIONS_QUERY = `
  query getPublicSessions($classId: Int!) {
    getPublicSessions(classId: $classId)
    {
      id
			classId
			date
			startTime
			endTime
			price
			created
			status
			currentCapacity
			availableCapacity
			capacity
			capacityOverride
			heldPlaces
			locationType
			isSessionBought
			canBeBought
			canBeReimbursed
			model
			duration
			subscriptionId
			clientEmail
			newStartTime
			newEndTime
			resourceEmail
			newStartDate
			newEndDate
			newLocation
      ...fragments
    }
  }`;

export const getPublicSessionsApiCall = async ({classId}, fragments = null) => apiCall({ query: GETPUBLICSESSIONS_QUERY, variables: {classId}, fragments });

const GETSESSIONSBYCLASSID_QUERY = `
  query getSessionsByClassId($classId: Int!) {
    getSessionsByClassId(classId: $classId)
    {
      id
			classId
			date
			startTime
			endTime
			price
			created
			status
			currentCapacity
			availableCapacity
			capacity
			capacityOverride
			heldPlaces
			locationType
			isSessionBought
			canBeBought
			canBeReimbursed
			model
			duration
			subscriptionId
			clientEmail
			newStartTime
			newEndTime
			resourceEmail
			newStartDate
			newEndDate
			newLocation
      ...fragments
    }
  }`;

export const getSessionsByClassIdApiCall = async ({classId}, fragments = null) => apiCall({ query: GETSESSIONSBYCLASSID_QUERY, variables: {classId}, fragments });

const GETSESSIONSFORMULTIPLEUPDATE_QUERY = `
  query getSessionsForMultipleUpdate($classId: Int!, $fromDate: DateTime!, $toDate: DateTime) {
    getSessionsForMultipleUpdate(classId: $classId, fromDate: $fromDate, toDate: $toDate)
  }`;

export const getSessionsForMultipleUpdateApiCall = async ({classId, fromDate, toDate}, ) => apiCall({ query: GETSESSIONSFORMULTIPLEUPDATE_QUERY, variables: {classId, fromDate, toDate}});

const CHECKMULTIPLESESSIONSUPDATE_QUERY = `
  query checkMultipleSessionsUpdate($requests: [SessionUpdateInput]!) {
    checkMultipleSessionsUpdate(requests: $requests)
  }`;

export const checkMultipleSessionsUpdateApiCall = async ({requests}, ) => apiCall({ query: CHECKMULTIPLESESSIONSUPDATE_QUERY, variables: {requests}});

const GETSESSIONSWITHINPERIOD_QUERY = `
  query getSessionsWithinPeriod($startTime: DateTime!, $endTime: DateTime!, $classId: Int) {
    getSessionsWithinPeriod(startTime: $startTime, endTime: $endTime, classId: $classId)
    {
      id
			startTime
			endTime
			classId
			className
      ...fragments
    }
  }`;

export const getSessionsWithinPeriodApiCall = async ({startTime, endTime, classId}, fragments = null) => apiCall({ query: GETSESSIONSWITHINPERIOD_QUERY, variables: {startTime, endTime, classId}, fragments });

const SAVESESSION_QUERY = `
  mutation saveSession($request: SessionCreateInput!, $isDeal: Boolean) {
    saveSession(request: $request, isDeal: $isDeal)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const saveSessionApiCall = async ({request, isDeal}, fragments = null) => apiCall({ query: SAVESESSION_QUERY, variables: {request, isDeal}, fragments });

const UPDATESESSIONCAPACITY_QUERY = `
  mutation updateSessionCapacity($sessionId: Int!, $capacity: Int, $resetCapacity: Boolean) {
    updateSessionCapacity(sessionId: $sessionId, capacity: $capacity, resetCapacity: $resetCapacity)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const updateSessionCapacityApiCall = async ({sessionId, capacity, resetCapacity}, fragments = null) => apiCall({ query: UPDATESESSIONCAPACITY_QUERY, variables: {sessionId, capacity, resetCapacity}, fragments });

const UPDATEMULTIPLESESSIONS_QUERY = `
  mutation updateMultipleSessions($requests: [SessionUpdateInput]!) {
    updateMultipleSessions(requests: $requests)
  }`;

export const updateMultipleSessionsApiCall = async ({requests}, ) => apiCall({ query: UPDATEMULTIPLESESSIONS_QUERY, variables: {requests}});

const UPDATESESSIONFROMEVENT_QUERY = `
  mutation updateSessionFromEvent($id: Int!, $startDate: DateTime!, $startTime: DateTime!, $endTime: DateTime!, $subscriptionsEmails: [String], $resourceId: Int, $locationType: Int, $address: String, $latitude: Float, $longitude: Float, $locationNote: String, $url: String) {
    updateSessionFromEvent(id: $id, startDate: $startDate, startTime: $startTime, endTime: $endTime, subscriptionsEmails: $subscriptionsEmails, resourceId: $resourceId, locationType: $locationType, address: $address, latitude: $latitude, longitude: $longitude, locationNote: $locationNote, url: $url)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const updateSessionFromEventApiCall = async ({id, startDate, startTime, endTime, subscriptionsEmails, resourceId, locationType, address, latitude, longitude, locationNote, url}, fragments = null) => apiCall({ query: UPDATESESSIONFROMEVENT_QUERY, variables: {id, startDate, startTime, endTime, subscriptionsEmails, resourceId, locationType, address, latitude, longitude, locationNote, url}, fragments });

const DELETESESSION_QUERY = `
  mutation deleteSession($id: Int!) {
    deleteSession(id: $id)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const deleteSessionApiCall = async ({id}, fragments = null) => apiCall({ query: DELETESESSION_QUERY, variables: {id}, fragments });

const CANCELSESSION_QUERY = `
  mutation cancelSession($id: Int!) {
    cancelSession(id: $id)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const cancelSessionApiCall = async ({id}, fragments = null) => apiCall({ query: CANCELSESSION_QUERY, variables: {id}, fragments });

const CANCELTOTALSESSION_QUERY = `
  mutation cancelTotalSession($sessionId: Int!, $classId: Int!) {
    cancelTotalSession(sessionId: $sessionId, classId: $classId)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const cancelTotalSessionApiCall = async ({sessionId, classId}, fragments = null) => apiCall({ query: CANCELTOTALSESSION_QUERY, variables: {sessionId, classId}, fragments });

const CHANGEUSERSESSIONSNUMBER_QUERY = `
  mutation changeUserSessionsNumber($id: Int!, $numberOfSessions: Int!, $startTime: DateTime, $endTime: DateTime, $action: Boolean) {
    changeUserSessionsNumber(id: $id, numberOfSessions: $numberOfSessions, startTime: $startTime, endTime: $endTime, action: $action)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const changeUserSessionsNumberApiCall = async ({id, numberOfSessions, startTime, endTime, action}, fragments = null) => apiCall({ query: CHANGEUSERSESSIONSNUMBER_QUERY, variables: {id, numberOfSessions, startTime, endTime, action}, fragments });

const COPYSESSIONS_QUERY = `
  mutation copySessions($sessionIds: [Int]!, $startTime: DateTime!, $startTimeDuplicated: DateTime!) {
    copySessions(sessionIds: $sessionIds, startTime: $startTime, startTimeDuplicated: $startTimeDuplicated)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const copySessionsApiCall = async ({sessionIds, startTime, startTimeDuplicated}, fragments = null) => apiCall({ query: COPYSESSIONS_QUERY, variables: {sessionIds, startTime, startTimeDuplicated}, fragments });
